var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return ((_vm.activeContent.length >= 0))?_c('Main',{attrs:{"brand":_vm.brand,"user-agent":_vm.userAgent}}):_c('Sub',{attrs:{"active-content":_vm.activeContent,"brand":_vm.brand}})}
var staticRenderFns = []

export { render, staticRenderFns }